<div class="custom-sponsors-toolbar navbar" *ngIf="campus && sponsorsList && sponsorsList.length > 0">

    <div class="container-fluid">

        <div class="row w-100 h-100"> 
            
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2 col-xxl-2 d-flex flex-row justify-content-center align-items-center mx-auto text-center">
                <h4 class="text-dark strong m-0">PARTICIPANTES</h4>
            </div>
            
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 col-xxl-10 d-flex flex-row justify-content-center align-items-center mx-auto text-center">
                <img *ngFor="let sponsor of sponsorsList" 
                     class="custom-sponsors-toolbar-default-image img-fluid rounded float-start me-2 me-lg-5" 
                     [src]="sponsor">
            </div>
    
        </div>
        
    </div>
    
</div>
